import React from 'react';
import { TextField, TextFieldProps } from './TextField';

export const TextAreaField = (props: Omit<TextFieldProps, 'isTextArea' | 'variant' | 'type'>) => (
    <TextField variant={'outlined'} type={'text'} isTextArea={true} {...props} />
);
